import { render, staticRenderFns } from "./input-date.vue?vue&type=template&id=39a81974"
import script from "./input-date.vue?vue&type=script&lang=js"
export * from "./input-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports